import { AxiosResponse } from 'axios'
import IRemoteContentService from 'src/system/content/services/IRemoteContentService'
import IDashboardApiResponse from 'src/system/content/api/IDashboardApiResponse'
import IDashboardService from 'src/system/content/services/IDashboardService'

export class DashboardService implements IDashboardService {
  constructor(private readonly remoteContentService: IRemoteContentService) {
    //
  }

  async fetchDashboardData(): Promise<IDashboardApiResponse> {
    const response: AxiosResponse<IDashboardApiResponse> = await this.remoteContentService.request(
      'GET',
      `/api/dashboard?start_date`
    )

    return response.data
  }
}
